// import React from "react";
// import "./Sidebar.css";
// import SidebarsContent from "./SidebarsContent";
// import { AiOutlineClose } from "react-icons/ai";
// import logo from "../../Assets/logo/image.png";

// const Sidebar = ({ isOpen, toggleSidebar }) => {
//   return (
//     <React.Fragment>
//       <div
//         className={`scroll-container overflow-y-auto left-0 w-64 bg-gradient-to-t from-[#0a0c1f] via-[#183f6f] to-[#bbcaf8] shadow fixed inset-y-0 transform transition-transform duration-300 ease-in-out ${
//           isOpen ? "translate-x-0" : "-translate-x-full"
//         } py-4 px-6 flex flex-col justify-between`}
//         style={{ zIndex: 50 }}
//       >
//         <div>
//           <div className="flex justify-between items-center px-4 mb-">
//             <div className="flex justify-center w-full items-center">
//               <img src={logo} alt="logo" className="h-16 w-40" />
//             </div>
//             <button
//               onClick={toggleSidebar}
//               className="text-gray-600 hover:text-[#2E3A8C] transition duration-300"
//             >
//               <AiOutlineClose size={20} />
//             </button>
//           </div>

//           <SidebarsContent />
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Sidebar;

import React from "react";
import SidebarsContent from "./SidebarsContent";
import { AiOutlineClose } from "react-icons/ai";
import logo from "../../Assets/logo/image.png";
import "./Sidebar.css";

const Sidebar = ({ isOpen, toggleSidebar, isSmallScreen }) => {
  return (
    <React.Fragment>
      {isOpen && isSmallScreen && (
        <div
          className="fixed inset-0 z-20"
          style={{
            background: "rgba(4,20,28,0.65)",
            backdropFilter: "blur(3px)",
          }}
          onClick={toggleSidebar}
        />
      )}

      <div
        className={`scroll-container overflow-y-auto fixed inset-y-0 left-0 w-64 flex flex-col
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}`}
        style={{
          zIndex: 50,
          background:
            "linear-gradient(175deg,#041c24 0%,#062a35 35%,#051f2a 65%,#030f18 100%)",
          borderRight: "1px solid rgba(14,154,181,0.15)",
        }}
      >
        {/* ── Right-edge glow line ── */}
        <div className="sidebar-edge-glow" />

        {/* ── Header ── */}
        <div
          className="flex items-center justify-between px-5 py-4 flex-shrink-0"
          style={{
            background:
              "linear-gradient(135deg,rgba(14,154,181,0.13) 0%,rgba(224,32,32,0.07) 100%)",
            borderBottom: "1px solid rgba(14,154,181,0.14)",
          }}
        >
          {/* Logo */}
          <div className="flex-1 flex justify-center">
            <img
              src={logo}
              alt="Nexgen"
              className="h-14 w-36 object-contain logo-glow"
            />
          </div>

          {/* Close button */}
          <button
            onClick={toggleSidebar}
            className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg transition-all duration-200"
            style={{
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "rgba(255,255,255,0.4)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(224,32,32,0.18)";
              e.currentTarget.style.borderColor = "rgba(224,32,32,0.35)";
              e.currentTarget.style.color = "#fca5a5";
              e.currentTarget.style.boxShadow = "0 0 10px rgba(224,32,32,0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.05)";
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)";
              e.currentTarget.style.color = "rgba(255,255,255,0.4)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <AiOutlineClose size={13} />
          </button>
        </div>

        {/* ── Nav content ── */}
        <div className="flex-1 overflow-y-auto py-3 px-3">
          <SidebarsContent />
        </div>

        {/* ── Footer brand strip ── */}
        <div
          className="flex-shrink-0 px-5 py-3 text-center"
          style={{
            borderTop: "1px solid rgba(14,154,181,0.12)",
            background: "rgba(0,0,0,0.3)",
          }}
        >
          <p
            className="text-[9px] font-black uppercase tracking-[0.22em]"
            style={{
              background: "linear-gradient(90deg,#0ec6e8,#e02020,#0ec6e8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Nexgen Admin Panel
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
